export default "/search-white.add0491249b9cbc01447d6cece275b6b.svg";